<template>
    <div>
        <ol v-if="items && items.length" class="space-y-0.5">
            <li v-for="(song, index) in items" :key="song.id + '-' + song.playedAt">
                <button type="button" @click="$emit('play', song)"
                    class="group flex w-full items-center gap-3 rounded-xl p-2 text-left transition-colors hover:bg-white/[0.06] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent"
                    :class="{ 'bg-white/[0.06]': isCurrent(song) }">
                    <span class="flex w-5 shrink-0 justify-center text-xs tabular-nums text-nomad-400">
                        <span v-if="isCurrent(song)" class="nl-eq" :class="{ 'is-paused': !isPlaying }"
                            aria-label="Now playing">
                            <span></span><span></span><span></span>
                        </span>
                        <template v-else>
                            <span class="group-hover:hidden">{{ index + 1 }}</span>
                            <span class="icon-play hidden text-nomad-accent group-hover:inline" aria-hidden="true"></span>
                        </template>
                    </span>
                    <img :src="song.cover || song.artist?.image" :alt="song.name"
                        class="h-11 w-11 shrink-0 rounded-lg object-cover ring-1 ring-white/10" loading="lazy" />
                    <span class="min-w-0 flex-1">
                        <span class="block truncate text-sm font-medium"
                            :class="isCurrent(song) ? 'text-nomad-accent' : 'text-white'">{{ song.name }}</span>
                        <span class="block truncate text-xs text-nomad-300">{{ song.artist?.name }}</span>
                    </span>
                    <span class="shrink-0 text-[0.6875rem] tabular-nums text-nomad-400">{{ formatPlayedTime(song.playedAt)
                        }}</span>
                </button>
            </li>
        </ol>

        <div v-else class="flex flex-col items-center px-6 py-14 text-center">
            <span class="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white/[0.05] text-2xl text-nomad-400 ring-1 ring-inset ring-white/[0.08]">
                <span class="icon-clock" aria-hidden="true"></span>
            </span>
            <p class="font-medium text-white">Nothing played yet</p>
            <p class="mt-1 text-sm text-nomad-400">Songs you play will show up here.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlayerHistory",
    props: {
        items: { type: Array, default: () => [] },
        currentId: { type: [Number, String], default: null },
        isPlaying: { type: Boolean, default: false },
    },
    emits: ["play"],
    methods: {
        isCurrent(song) {
            return this.currentId !== null && song.id === this.currentId;
        },
        formatPlayedTime(playedAt) {
            const date = new Date(playedAt);
            const now = new Date();
            const diffInMinutes = Math.floor((now - date) / (1000 * 60));

            if (diffInMinutes < 1) return "Now";
            if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

            const diffInHours = Math.floor(diffInMinutes / 60);
            if (diffInHours < 24) return `${diffInHours}h ago`;

            const diffInDays = Math.floor(diffInHours / 24);
            return `${diffInDays}d ago`;
        },
    },
};
</script>
